<template>
  <div>
    <div class="group flex h-9 items-center gap-2 pl-3 text-xs font-medium tracking-wide text-neutral-500 uppercase">
      <a
        v-ripple
        class="group/label mr-auto flex flex-1 cursor-pointer items-center gap-2 transition-colors duration-200 hover:text-neutral-700"
        @click.stop="on_toggle"
      >
        <span>
          {{ title }}
        </span>
        <span
          :class="[
            'chevron opacity-0 transition-opacity duration-150 group-hover/label:opacity-100',
            { rotated: is_open },
          ]"
        >
          <FontAwesomeIcon
            class="text-neutral-400"
            icon="chevron-down"
            size="xs"
          />
        </span>
      </a>
      <button
        v-if="on_create"
        v-tooltip.right="$t('project.actions.submit')"
        type="button"
        class="flex size-6 items-center justify-center rounded-md text-neutral-700 transition-colors duration-150 hover:bg-selected hover:text-neutral-900 focus:bg-selected"
        data-test="sidebar-create-project"
        @click.stop="on_create"
      >
        <FontAwesomeIcon :icon="['far', 'plus']" />
      </button>
    </div>
    <transition name="fade-slide">
      <ul
        v-if="is_open"
        class="relative m-0 list-none rounded px-2 py-1"
      >
        <div
          v-if="is_fetching"
          class="flex flex-col gap-2"
        >
          <Skeleton
            borderRadius="16px"
            class="mx-4 mb-2"
            width="18rem"
          />
          <Skeleton
            borderRadius="16px"
            class="mx-4 mb-2"
            width="15rem"
          />
        </div>
        <div
          v-else-if="projects.length > 0"
          class="flex flex-col gap-1"
        >
          <li
            v-for="project in projects"
            :key="project.id"
          >
            <slot :project="project" />
          </li>
        </div>
        <div
          v-else
          class="px-2 py-1 text-center text-sm text-neutral-500"
        >
          {{ $t('project.labels.noProjects') }}
        </div>
      </ul>
    </transition>
  </div>
</template>

<script setup>
import Skeleton from 'primevue/skeleton';

defineProps({
  title: { type: String, default: '' },
  is_open: { type: Boolean },
  on_toggle: { type: Function, default: () => {} },
  on_create: { type: Function, default: null },
  projects: { type: Array, default: () => [] },
  is_fetching: { type: Boolean },
});
</script>

<style scoped>
.chevron {
  display: inline-block;
  transition: transform 0.2s;
}
.chevron.rotated {
  transform: rotate(180deg);
}

/* Fade and slide transition */
.fade-slide-enter-active,
.fade-slide-leave-active {
  transition:
    opacity 0.18s cubic-bezier(0.4, 0, 0.2, 1),
    transform 0.18s cubic-bezier(0.4, 0, 0.2, 1);
}
.fade-slide-enter-from,
.fade-slide-leave-to {
  opacity: 0;
  transform: translateY(-8px);
}
.fade-slide-enter-to,
.fade-slide-leave-from {
  opacity: 1;
  transform: translateY(0);
}
</style>
